'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCustomStyled = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

var _iconsPropType = require('../../iconsPropType');

var _styleMixins = require('../../styles/styleMixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = _extends({}, _iconsPropType.iconsPropType, {
  /** Set icon's source */
  src: _propTypes2.default.string
});

var defaultProps = {
  src: '',
  border: false,
  rounded: false,
  size: 'normal',
  colorScheme: 'default',
  color: '',
  backgroundColor: '',
  flip: 'none',
  rotate: 0
};

var IconImg = function IconImg(_ref) {
  var src = _ref.src;
  return '        \n  background-image: url(\'' + src + '\');\n';
};

// STYLES
var IconCustomStyled = exports.IconCustomStyled = _styledComponents2.default.div.withConfig({
  displayName: 'IconCustomStyled'
})(['text-align:center;flex-shrink:0;position:relative;background-position:center;background-repeat:no-repeat;box-sizing:border-box;', ';', ';', ';', ';', ';', ';', ';'], (0, _reactackleCore.transition)('background-color, color, opacity'), _styleMixins.sizeProps, _styleMixins.backgroundProps, _styleMixins.border, _styleMixins.borderRadius, _styleMixins.transform, IconImg);

IconCustomStyled.propTypes = propTypes;
IconCustomStyled.defaultProps = defaultProps;
IconCustomStyled.displayName = 'IconCustomStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-icons/dist/IconCustom/styles/IconCustomStyled.js
// module id = 710
// module chunks = 0